import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { media } from '../../search-common/helpers'
import { fontFamilies } from '../../search-common/settings'
import { translate } from '../../modules/helper-functions'
import { colors } from '../../search-common/settings'


const TitleStyles = styled.h1`
  font-family: ${fontFamilies.saol};
  font-weight: 600;
  line-height: 1.2;
  padding: 24px 24px 12px;
  font-size: 26px;
  width: 100%;
  max-width: 1440px;
  margin: auto;
  background-color: ${colors.grayTone1};

  ${media.tablet`
    font-size: 36px;
    margin-bottom: 24px;
  `}

  ${media.desktop`
    font-size: 46px;
  `}

  ${media.lDesktop`
    font-size: 52px;
  `}
`

/**
*
*/
const Title = ({ translations }) => (
   <TitleStyles>{translate( translations, 'Find a location' )}</TitleStyles>
)


/**
 * Map the redux state to component props.
 *
 * @param {object} state
 * @return {object}
 */
const mapStateToProps = ( state ) => ({
  translations: state.translations
})

Title.propTypes = {
  translations: PropTypes.object.isRequired
}

export default connect( mapStateToProps )( Title )
